<script lang="ts">
  // import { onDestroy } from "svelte";
  // import VocabStore from "./stores/vocab-store.js";
  import vocabData from "./stores/vocab-data.js";
  import Team from "./Team.svelte";
  import BtnLearn from "./BtnLearn.svelte";
  import BtnPlay from "./BtnPlay.svelte";
  import Square from "./Square.svelte";
  import Modal from "./Modal.svelte";
  import MsgWhosFirst from "./MsgWhosFirst.svelte";
  import MsgLearnVocab from "./MsgLearnVocab.svelte";
  import MsgWinner from "./MsgWinner.svelte";

  // DATA STORE
  // let vocabData;
  // const unsubscribe = VocabStore.subscribe((items) => (vocabData = items));
  // onDestroy(() => unsubscribe());
  // $: console.log(vocabData);

  /******************
     Game Content
  *******************/
  // Fisher-Yates method to shuffle vocabulary array
  function shuffle(array) {
    var i = 0,
      j = 0,
      temp = null;

    for (i = array.length - 1; i > 0; i -= 1) {
      j = Math.floor(Math.random() * (i + 1));
      temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  interface Vocab {
    content: string;
    matchid: string;
  }
  // Shuffled vocab set used with {#each} loop
  const halloweenVocab: Vocab[] = shuffle(vocabData.halloween);
  let practiceVocab: boolean = false;

  /*****************
    Teams and Turns
  *******************/
  let modalShowing: boolean = false;
  // $: console.log(modalShowing);
  let teamOne: string = "spiders";
  let teamTwo: string = "bats";
  let whoseTurn: string = "";

  const goFirst = (e) => {
    whoseTurn = e.target.textContent.toLowerCase();
    modalShowing = false;
  };

  const switchTurns = () => {
    whoseTurn === "bats" ? (whoseTurn = "spiders") : (whoseTurn = "bats");
  };

  /******************
    Playing the Game
  *******************/
  const initGame = () => {
    modalShowing = true;
    gameInSession = true;
  };

  let gameInSession: boolean = false;

  // Disable and Enable gameboard
  let clickable: boolean = true;
  const enableDisableBoard = () => (clickable = !clickable);

  const resetGame = () => {
    shuffle(vocabData.halloween);
    clearPicks();
    clearPickIDs();
    clearMatchIDs();
    whoseTurn = "";
    winner = "";
    teamOnePoints = 0;
    teamTwoPoints = 0;
    gameInSession = true;
  };

  // Containers for Choosing two squares
  let picks: Array<string> = [];
  let picksIDs: Array<string> = [];
  // Container for correct matches
  let matchedIDs: Array<string> = [];
  // $: console.log(picks, picksIDs, matchedIDs);

  let winner: string;
  let teamOnePoints = 0;
  let teamTwoPoints = 0;
  const winaPoint = () => {
    whoseTurn === teamOne ? (teamOnePoints += 1) : (teamTwoPoints += 1);
  };

  // Decide if chosen squares match or not
  const handlePicks = (e) => {
    let choice: string = e.target.dataset.name;
    let id: string = e.target.id;

    // Prevent same square being clicked twice and scoring a point
    if (id !== picksIDs[0]) {
      picks = [choice, ...picks];
      picksIDs = [id, ...picksIDs];
    } else {
      choice = "";
      id = "";
      alert("You can't click the same square twice!");
    }

    // Temp. disable board while 2 picks are being compared
    if (picks.length === 2) {
      enableDisableBoard();
      comparePicks();
      clearPicks();
    }
  };

  const clearPicks = () => (picks = []);
  const clearPickIDs = () => (picksIDs = []);
  const clearMatchIDs = () => (matchedIDs = []);

  // Do the word and image match or not?
  const comparePicks = () => {
    if (picks[0] === picks[1]) {
      // console.log("Match");
      winaPoint();
      playSFXAudio("right");
      // Store IDs that are matches
      matchedIDs = matchedIDs.concat(picksIDs);

      setTimeout(clearPickIDs, 1000);
      setTimeout(enableDisableBoard, 1000);
      if (teamOnePoints + teamTwoPoints === halloweenVocab.length / 2) {
        handleGameOver();
      }
    } else {
      playSFXAudio("wrong");
      setTimeout(clearPickIDs, 1000);
      setTimeout(enableDisableBoard, 1000);
      switchTurns();
    }
  };

  const decideWinner = () => {
    if (teamOnePoints > teamTwoPoints) {
      winner = teamOne;
      playSFXAudio("winner");
      // console.log(`The winner is team ${teamOne.toUpperCase()}`);
    } else if (teamOnePoints === teamTwoPoints) {
      winner = "none";
      // console.log("It's a tie!");
    } else {
      winner = teamTwo;
      playSFXAudio("winner");
      // console.log(`The winner is team ${teamTwo.toUpperCase()}`);
    }
  };

  const handleGameOver = () => {
    decideWinner();
    modalShowing = true;
    gameInSession = false;
  };

  const showHideVocabList = () => {
    modalShowing = !modalShowing;
    practiceVocab = !practiceVocab;
  };

  const playAudio = (e) => {
    let audiofile = new Audio(`audio/${e.detail.target.id}.mp3`);
    audiofile.play();
  };

  const playSFXAudio = (fileName: string) => {
    let audiofile = new Audio(`audio/${fileName}.mp3`);
    audiofile.play();
  }

</script>

<style>
  main {
    grid-area: main;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    /* min-height: calc(100vw - 70px); */
  }

  header {
    grid-area: teams;
    width: 100vw;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
  }

  #gameboard {
    grid-area: board;
    width: 100%;
    margin: 5% 0 0 0;
    padding: 0;
    display: grid;
    grid-template-columns: auto auto auto auto;
    grid-gap: 2px;
    justify-content: center;
  }

  #playlearn-btn-cont {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }

  #cite-cont {
    width: 100%;
    text-align: center;
  }

  cite {
    font-size: 0.5rem;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 280px) {
    #gameboard {
      margin: 5% 0 0 0;
      grid-template-columns: auto auto auto auto;
      justify-content: flex-start;
    }
  }
  @media only screen and (max-width: 360px) {
    #gameboard {
      justify-content: center;
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    #gameboard {
      margin: 10%;
      grid-template-columns: auto auto auto auto auto;
    }

    #playlearn-btn-cont {
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
      width: 40%;
    }

    cite {
      font-size: 1rem;
    }
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    #gameboard {
      margin: 5%;
    }
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    #gameboard {
      margin: 0%;
    }

    #playlearn-btn-cont {
      align-items: center;
      justify-content: space-around;
    }
  }
</style>

<main>
  <Modal {modalShowing}>
    {#if !whoseTurn && gameInSession}
      <MsgWhosFirst {teamOne} {teamTwo} on:click={goFirst} />
    {/if}

    {#if winner}
      <MsgWinner
        message={winner === 'none' ? "It's a tie!" : `The ${winner.toUpperCase()} Win!`}
        on:click={() => (modalShowing = false)}
        on:play={resetGame} />
    {/if}

    {#if practiceVocab}
      <MsgLearnVocab
        {vocabData}
        on:click={showHideVocabList}
        on:playaudio={(e) => playAudio(e)} />
    {/if}
  </Modal>

  <header>
    <Team
      teamName={teamOne}
      imgUrl="https://upload.wikimedia.org/wikipedia/commons/c/c6/Spider.svg"
      {whoseTurn}
      points={teamOnePoints} />
    <div id="playlearn-btn-cont">
      <BtnPlay {gameInSession} on:click={initGame} />
      <BtnLearn {modalShowing} on:click={showHideVocabList} />
    </div>
    <Team
      teamName={teamTwo}
      imgUrl="https://image.flaticon.com/icons/svg/31/31157.svg"
      {whoseTurn}
      points={teamTwoPoints} />
  </header>

  <section id="gameboard">
    {#each halloweenVocab as { content, matchid }, i}
      <Square
        clickable={gameInSession}
        {content}
        {matchid}
        guideNumber={String(i + 1)}
        showing={String(i) === picksIDs[0] || String(i) === picksIDs[1] || matchedIDs.includes(String(i))}
        wordID={String(i)}
        on:click={(e) => handlePicks(e)} />
    {/each}
  </section>
  <div id="cite-cont">
    <cite>Images by <a href="https://commons.wikimedia.org/wiki/File:Creative-Tail-Halloween-ghost.svg" target="_blank">creativetail.com</a></cite>
  </div>
</main>
